"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
var a = {
	16: {
		Artwork: (e) => {
			let a = i();
			return /* @__PURE__ */ r(t, {
				viewBox: "0 0 16 16",
				fill: "none",
				...e,
				children: [
					/* @__PURE__ */ n("path", {
						d: "M4.47288 1.77789C5.5664 1.77796 6.60709 2.96332 7.70062 2.96332H10.2032C11.5017 2.96332 12.1509 2.96336 12.6469 3.22166C13.0832 3.44888 13.4381 3.81116 13.6605 4.25709C13.9132 4.76415 13.9132 5.42819 13.9132 6.75573V9.95577C13.9132 11.4492 13.9129 12.1958 13.6285 12.7662C13.3785 13.268 12.9795 13.6758 12.4886 13.9315C11.9305 14.2221 11.2002 14.2225 9.73923 14.2225H3.70997C2.41157 14.2225 1.76231 14.2224 1.26632 13.9642C0.83 13.7369 0.475038 13.374 0.25272 12.9281C7.68777e-05 12.421 8.56469e-10 11.7573 0 10.4301V4.14806C0.000122598 2.83912 1.03815 1.77802 2.31864 1.77789H4.47288Z",
						fill: "#027ED4"
					}),
					/* @__PURE__ */ n("mask", {
						id: `${a}-mask0_218_65`,
						style: { maskType: "luminance" },
						maskUnits: "userSpaceOnUse",
						x: 0,
						y: 1,
						width: 14,
						height: 14,
						children: /* @__PURE__ */ n("path", {
							d: "M4.47288 1.77789C5.5664 1.77796 6.60709 2.96332 7.70062 2.96332H10.2032C11.5017 2.96332 12.1509 2.96336 12.6469 3.22166C13.0832 3.44888 13.4381 3.81116 13.6605 4.25709C13.9132 4.76415 13.9132 5.42819 13.9132 6.75573V9.95577C13.9132 11.4492 13.9129 12.1958 13.6285 12.7662C13.3785 13.268 12.9795 13.6758 12.4886 13.9315C11.9305 14.2221 11.2002 14.2225 9.73923 14.2225H3.70997C2.41157 14.2225 1.76231 14.2224 1.26632 13.9642C0.83 13.7369 0.475038 13.374 0.25272 12.9281C7.68777e-05 12.421 8.56469e-10 11.7573 0 10.4301V4.14806C0.000122598 2.83912 1.03815 1.77802 2.31864 1.77789H4.47288Z",
							fill: "white"
						})
					}),
					/* @__PURE__ */ n("g", {
						mask: `url(#${a}-mask0_218_65)`,
						children: /* @__PURE__ */ n("path", {
							d: "M7.70053 2.96336V3.25966H10.2031V2.96336V2.66706H7.70053V2.96336ZM10.2031 2.96336V3.25966C10.8572 3.25966 11.3303 3.25989 11.7024 3.29098C12.071 3.32178 12.3149 3.38138 12.5152 3.48571L12.6468 3.2217L12.7785 2.95769C12.4828 2.80372 12.1541 2.73414 11.7496 2.70035C11.3484 2.66684 10.8476 2.66706 10.2031 2.66706V2.96336ZM12.6468 3.2217L12.5152 3.48571C12.8971 3.68461 13.2077 4.00164 13.4022 4.39167L13.6604 4.25712L13.9186 4.12262C13.6684 3.62079 13.269 3.21323 12.7785 2.95769L12.6468 3.2217ZM13.6604 4.25712L13.4022 4.39167C13.5042 4.59645 13.5626 4.84586 13.5926 5.22289C13.623 5.60335 13.6233 6.0871 13.6233 6.75577H13.9131H14.203C14.203 6.09689 14.2032 5.58484 14.1705 5.17465C14.1374 4.761 14.0694 4.42488 13.9186 4.12262L13.6604 4.25712ZM13.9131 6.75577H13.6233V9.95579H13.9131H14.203V6.75577H13.9131ZM13.9131 9.95579H13.6233C13.6233 10.7074 13.623 11.2532 13.5885 11.683C13.5544 12.1093 13.4881 12.3952 13.3702 12.6317L13.6284 12.7662L13.8867 12.9008C14.0531 12.5669 14.1292 12.1943 14.1663 11.7314C14.2032 11.2718 14.203 10.6977 14.203 9.95579H13.9131ZM13.6284 12.7662L13.3702 12.6317C13.1479 13.0778 12.7932 13.4403 12.3569 13.6676L12.4885 13.9316L12.6201 14.1956C13.1655 13.9115 13.6089 13.4583 13.8867 12.9008L13.6284 12.7662ZM12.4885 13.9316L12.3569 13.6676C12.1256 13.788 11.8458 13.8558 11.4288 13.8907C11.0084 13.9259 10.4744 13.9262 9.73913 13.9262V14.2225V14.5189C10.4649 14.5189 11.0265 14.519 11.4761 14.4813C11.929 14.4434 12.2935 14.3657 12.6201 14.1956L12.4885 13.9316ZM9.73913 14.2225V13.9262H3.70988V14.2225V14.5189H9.73913V14.2225ZM3.70988 14.2225V13.9262C3.05591 13.9262 2.58283 13.926 2.21076 13.895C1.84207 13.864 1.59813 13.8045 1.39779 13.7001L1.26623 13.9642L1.13464 14.2282C1.43029 14.3822 1.759 14.4518 2.16353 14.4855C2.56469 14.519 3.06546 14.5189 3.70988 14.5189V14.2225ZM1.26623 13.9642L1.39779 13.7001C1.01601 13.5013 0.705423 13.1838 0.510898 12.7935L0.252632 12.9281L-0.00564915 13.0626C0.244458 13.5644 0.643775 13.9725 1.13464 14.2282L1.26623 13.9642ZM0.252632 12.9281L0.510898 12.7935C0.408851 12.5887 0.35056 12.3394 0.320426 11.9625C0.290014 11.5822 0.289771 11.0986 0.289771 10.4301H-8.84235e-05H-0.289947C-0.289947 11.0889 -0.290153 11.6008 -0.257365 12.0108C-0.2243 12.4244 -0.156244 12.7604 -0.00564915 13.0626L0.252632 12.9281ZM-8.84235e-05 10.4301H0.289771V4.1481H-8.84235e-05L-0.289947 4.14807V10.4301H-8.84235e-05ZM-8.84235e-05 4.1481H0.289771C0.289878 3.00276 1.19814 2.07434 2.31858 2.07423L2.31856 1.77793V1.48163C0.877995 1.48177 -0.289809 2.67549 -0.289947 4.14807L-8.84235e-05 4.1481ZM2.31856 1.77793L2.31858 2.07423H4.4728V1.77793L4.47281 1.48163H2.31856V1.77793ZM4.4728 1.77793V2.07423C4.93166 2.07426 5.39698 2.32481 5.94827 2.63101C6.46409 2.91752 7.06588 3.25966 7.70053 3.25966V2.96336V2.66706C7.24167 2.66706 6.77633 2.41652 6.22504 2.11032C5.70923 1.82382 5.10746 1.48167 4.47281 1.48163L4.4728 1.77793Z",
							fill: `url(#${a}-paint0_linear_218_65)`
						})
					}),
					/* @__PURE__ */ n("path", {
						d: "M5.07749 4.88885H11.2814C12.188 4.88885 12.8581 4.889 13.3745 4.93677C13.8903 4.98451 14.2327 5.07915 14.4927 5.25344C14.9676 5.57188 15.3022 6.06762 15.4241 6.63471C15.4908 6.94506 15.4548 7.30574 15.3147 7.81527C15.1744 8.32549 14.9353 8.96586 14.6123 9.83197L13.9051 11.7285C13.5725 12.6201 13.4176 13.0287 13.1578 13.3278C12.9243 13.5964 12.631 13.8035 12.3025 13.9306C11.9364 14.0723 11.5077 14.0744 10.5742 14.0744H4.37028C3.46349 14.0744 2.79283 14.0742 2.2765 14.0265C1.76085 13.9787 1.41821 13.8847 1.15828 13.7105C0.683428 13.3921 0.34948 12.8962 0.227558 12.3293C0.160839 12.0188 0.196818 11.6577 0.336936 11.1479C0.477195 10.6378 0.715719 9.99731 1.03871 9.13126L1.74593 7.23541C2.07854 6.34356 2.2333 5.93455 2.49321 5.63539C2.72658 5.3668 3.02055 5.1605 3.3492 5.03329C3.71524 4.89163 4.1438 4.88885 5.07749 4.88885Z",
						fill: "#027ED4",
						stroke: `url(#${a}-paint1_linear_218_65)`,
						strokeWidth: .370375
					}),
					/* @__PURE__ */ n("path", {
						opacity: .2,
						d: "M1.61072 7.1824C1.93914 6.30182 2.10335 5.86153 2.38512 5.53722C2.63404 5.2507 2.94722 5.03015 3.29779 4.89445C3.69462 4.74084 4.15558 4.74084 5.0775 4.74084H11.2813C13.0893 4.74084 13.9933 4.74084 14.5725 5.12916C15.079 5.46883 15.4356 5.99769 15.5655 6.60259C15.7142 7.29411 15.3921 8.15759 14.748 9.88454L14.0407 11.7809C13.7124 12.6615 13.5482 13.1018 13.2663 13.4261C13.0174 13.7126 12.7043 13.9331 12.3537 14.0689C11.9569 14.2225 11.4959 14.2225 10.574 14.2225H4.37025C2.56219 14.2225 1.65817 14.2225 1.07901 13.8341C0.572403 13.4945 0.215961 12.9656 0.0859492 12.3608C-0.062681 11.6692 0.259367 10.8057 0.903461 9.0787L1.61072 7.1824Z",
						fill: `url(#${a}-paint2_linear_218_65)`
					}),
					/* @__PURE__ */ r("defs", { children: [
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint0_linear_218_65`,
							x1: 6.95652,
							y1: 1.77793,
							x2: 6.95652,
							y2: 14.2225,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint1_linear_218_65`,
							x1: 7.82567,
							y1: 4.74093,
							x2: 7.82567,
							y2: 14.2225,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint2_linear_218_65`,
							x1: -1.01495,
							y1: 4.74084,
							x2: 8.76212,
							y2: 13.85,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", { stopColor: "white" }), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						})
					] })
				]
			});
		},
		width: 16,
		height: 16
	},
	24: {
		Artwork: (e) => {
			let a = i();
			return /* @__PURE__ */ r(t, {
				viewBox: "0 0 24 24",
				fill: "none",
				...e,
				children: [
					/* @__PURE__ */ n("path", {
						d: "M6.70932 2.66687C8.3496 2.66698 9.91063 4.44501 11.5509 4.44501H15.3049C17.2526 4.44501 18.2264 4.44507 18.9704 4.83252C19.6248 5.17335 20.1572 5.71678 20.4908 6.38566C20.8699 7.14626 20.8699 8.14231 20.8699 10.1336V14.9337C20.8699 17.1739 20.8693 18.2937 20.4428 19.1493C20.0677 19.902 19.4693 20.5138 18.7329 20.8972C17.8958 21.3332 16.8003 21.3338 14.6089 21.3338H5.56495C3.61735 21.3338 2.64346 21.3336 1.89948 20.9463C1.245 20.6054 0.712557 20.0611 0.379081 19.3921C0.000115317 18.6316 1.2847e-09 17.636 0 15.6452V6.22213C0.000183897 4.2587 1.55722 2.66706 3.47796 2.66687H6.70932Z",
						fill: "#027ED4"
					}),
					/* @__PURE__ */ n("mask", {
						id: `${a}-mask0_218_70`,
						style: { maskType: "luminance" },
						maskUnits: "userSpaceOnUse",
						x: 0,
						y: 2,
						width: 21,
						height: 20,
						children: /* @__PURE__ */ n("path", {
							d: "M6.70932 2.66687C8.3496 2.66698 9.91063 4.44501 11.5509 4.44501H15.3049C17.2526 4.44501 18.2264 4.44507 18.9704 4.83252C19.6248 5.17335 20.1572 5.71678 20.4908 6.38566C20.8699 7.14626 20.8699 8.14231 20.8699 10.1336V14.9337C20.8699 17.1739 20.8693 18.2937 20.4428 19.1493C20.0677 19.902 19.4693 20.5138 18.7329 20.8972C17.8958 21.3332 16.8003 21.3338 14.6089 21.3338H5.56495C3.61735 21.3338 2.64346 21.3336 1.89948 20.9463C1.245 20.6054 0.712557 20.0611 0.379081 19.3921C0.000115317 18.6316 1.2847e-09 17.636 0 15.6452V6.22213C0.000183897 4.2587 1.55722 2.66706 3.47796 2.66687H6.70932Z",
							fill: "white"
						})
					}),
					/* @__PURE__ */ n("g", {
						mask: `url(#${a}-mask0_218_70)`,
						children: /* @__PURE__ */ n("path", {
							d: "M11.5508 4.445V4.88946H15.3048V4.445V4.00056H11.5508V4.445ZM15.3048 4.445V4.88946C16.2858 4.88946 16.9954 4.88981 17.5536 4.93644C18.1065 4.98264 18.4724 5.07204 18.7728 5.22853L18.9703 4.83252L19.1677 4.43651C18.7243 4.20555 18.2312 4.10119 17.6244 4.05049C17.0226 4.00023 16.2714 4.00056 15.3048 4.00056V4.445ZM18.9703 4.83252L18.7728 5.22853C19.3457 5.52688 19.8116 6.00242 20.1033 6.58747L20.4907 6.38565L20.878 6.18389C20.5027 5.43115 19.9036 4.81982 19.1677 4.43651L18.9703 4.83252ZM20.4907 6.38565L20.1033 6.58747C20.2564 6.89465 20.3439 7.26876 20.3889 7.8343C20.4345 8.405 20.4349 9.13062 20.4349 10.1336H20.8698H21.3046C21.3046 9.1453 21.3048 8.37723 21.2558 7.76194C21.2062 7.14146 21.1042 6.63728 20.878 6.18389L20.4907 6.38565ZM20.8698 10.1336H20.4349V14.9337H20.8698H21.3046V10.1336H20.8698ZM20.8698 14.9337H20.4349C20.4349 16.061 20.4345 16.8798 20.3828 17.5245C20.3316 18.164 20.2321 18.5928 20.0553 18.9476L20.4427 19.1493L20.8302 19.3512C21.0798 18.8504 21.1939 18.2914 21.2495 17.597C21.3048 16.9077 21.3046 16.0465 21.3046 14.9337H20.8698ZM20.4427 19.1493L20.0553 18.9476C19.7219 19.6166 19.1899 20.1604 18.5355 20.5013L18.7328 20.8973L18.9303 21.2933C19.7483 20.8672 20.4133 20.1875 20.8302 19.3512L20.4427 19.1493ZM18.7328 20.8973L18.5355 20.5013C18.1884 20.682 17.7688 20.7837 17.1432 20.836C16.5126 20.8888 15.7117 20.8893 14.6087 20.8893V21.3337V21.7783C15.6974 21.7783 16.5398 21.7784 17.2142 21.7219C17.8936 21.6651 18.4403 21.5485 18.9303 21.2933L18.7328 20.8973ZM14.6087 21.3337V20.8893H5.56487V21.3337V21.7783H14.6087V21.3337ZM5.56487 21.3337V20.8893C4.58391 20.8893 3.87429 20.8889 3.31619 20.8424C2.76315 20.796 2.39724 20.7067 2.09673 20.5501L1.8994 20.9463L1.70201 21.3423C2.14548 21.5732 2.63855 21.6776 3.24535 21.7283C3.84709 21.7785 4.59823 21.7783 5.56487 21.7783V21.3337ZM1.8994 20.9463L2.09673 20.5501C1.52406 20.2519 1.05818 19.7757 0.766393 19.1902L0.378993 19.3921L-0.00842795 19.5938C0.366733 20.3465 0.965708 20.9587 1.70201 21.3423L1.8994 20.9463ZM0.378993 19.3921L0.766393 19.1902C0.613322 18.883 0.525886 18.509 0.480684 17.9437C0.435067 17.3733 0.434702 16.6479 0.434702 15.6451H-8.6844e-05H-0.434875C-0.434875 16.6333 -0.435183 17.4012 -0.386001 18.0162C-0.336404 18.6365 -0.234321 19.1405 -0.00842795 19.5938L0.378993 19.3921ZM-8.6844e-05 15.6451H0.434702V6.22212H-8.6844e-05L-0.434875 6.22208V15.6451H-8.6844e-05ZM-8.6844e-05 6.22212H0.434702C0.434862 4.50411 1.79726 3.11148 3.47792 3.11132L3.47788 2.66686V2.22241C1.31704 2.22262 -0.434667 4.01321 -0.434875 6.22208L-8.6844e-05 6.22212ZM3.47788 2.66686L3.47792 3.11132H6.70924V2.66686L6.70926 2.22241H3.47788V2.66686ZM6.70924 2.66686V3.11132C7.39753 3.11136 8.09551 3.48719 8.92246 3.94649C9.69619 4.37624 10.5989 4.88946 11.5508 4.88946V4.445V4.00056C10.8625 4.00056 10.1645 3.62475 9.33761 3.16545C8.56389 2.7357 7.66124 2.22247 6.70926 2.22241L6.70924 2.66686Z",
							fill: `url(#${a}-paint0_linear_218_70)`
						})
					}),
					/* @__PURE__ */ n("path", {
						d: "M7.61618 7.33325H16.922C18.2819 7.33325 19.2871 7.33346 20.0617 7.40512C20.8354 7.47673 21.349 7.6187 21.739 7.88013C22.4513 8.35778 22.9533 9.10139 23.1361 9.95203C23.2361 10.4176 23.1821 10.9586 22.972 11.7229C22.7616 12.4882 22.4029 13.4488 21.9184 14.7479L20.8575 17.5928C20.3587 18.9301 20.1263 19.5431 19.7366 19.9917C19.3865 20.3945 18.9465 20.7052 18.4537 20.8959C17.9046 21.1084 17.2615 21.1116 15.8612 21.1116H6.55537C5.19519 21.1116 4.18919 21.1113 3.41471 21.0397C2.64123 20.968 2.12726 20.8271 1.73738 20.5657C1.0251 20.0881 0.524174 19.3443 0.341292 18.4938C0.241213 18.0281 0.295181 17.4865 0.505358 16.7218C0.715746 15.9566 1.07353 14.9959 1.55802 13.6969L2.61884 10.8531C3.11777 9.51531 3.3499 8.90179 3.73976 8.45305C4.08982 8.05017 4.53079 7.74072 5.02375 7.54991C5.57281 7.33741 6.21566 7.33325 7.61618 7.33325Z",
						fill: "#027ED4",
						stroke: `url(#${a}-paint1_linear_218_70)`,
						strokeWidth: .555563
					}),
					/* @__PURE__ */ n("path", {
						opacity: .2,
						d: "M2.41613 10.7737C2.90876 9.4528 3.15507 8.79236 3.57773 8.30589C3.95111 7.87611 4.42088 7.54528 4.94674 7.34173C5.54197 7.11133 6.23342 7.11133 7.6163 7.11133H16.922C19.634 7.11133 20.9901 7.11133 21.8587 7.6938C22.6186 8.2033 23.1534 8.99659 23.3484 9.90395C23.5713 10.9412 23.0882 12.2364 22.1221 14.8269L21.0611 17.6714C20.5686 18.9923 20.3223 19.6528 19.8995 20.1392C19.5262 20.569 19.0564 20.8998 18.5306 21.1034C17.9354 21.3338 17.2439 21.3338 15.8611 21.3338H6.55542C3.84334 21.3338 2.4873 21.3338 1.61856 20.7512C0.858651 20.2417 0.323987 19.4485 0.12897 18.5412C-0.0939758 17.5038 0.389096 16.2086 1.35524 13.6181L2.41613 10.7737Z",
						fill: `url(#${a}-paint2_linear_218_70)`
					}),
					/* @__PURE__ */ r("defs", { children: [
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint0_linear_218_70`,
							x1: 10.4348,
							y1: 2.66686,
							x2: 10.4348,
							y2: 21.3337,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint1_linear_218_70`,
							x1: 11.7385,
							y1: 7.11137,
							x2: 11.7385,
							y2: 21.3337,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint2_linear_218_70`,
							x1: -1.52237,
							y1: 7.11133,
							x2: 13.1432,
							y2: 20.7751,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", { stopColor: "white" }), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						})
					] })
				]
			});
		},
		width: 24,
		height: 24
	},
	40: {
		Artwork: (e) => {
			let a = i();
			return /* @__PURE__ */ r(t, {
				viewBox: "0 0 40 40",
				fill: "none",
				...e,
				children: [
					/* @__PURE__ */ n("path", {
						d: "M11.1822 4.4447C13.916 4.44488 16.5177 7.40827 19.2516 7.40827H25.5081C28.7544 7.40827 30.3773 7.40836 31.6173 8.05412C32.708 8.62218 33.5953 9.52788 34.1513 10.6427C34.7831 11.9104 34.7831 13.5704 34.7831 16.8893V24.8894C34.7831 28.623 34.7822 30.4895 34.0713 31.9155C33.4462 33.17 32.4489 34.1895 31.2215 34.8286C29.8264 35.5553 28.0006 35.5562 24.3481 35.5562H9.27492C6.02892 35.5562 4.40577 35.556 3.1658 34.9104C2.075 34.3422 1.18759 33.4351 0.631801 32.3202C0.000192194 31.0526 2.14117e-09 29.3932 0 26.0752V10.3701C0.000306495 7.09776 2.59537 4.44501 5.79661 4.4447H11.1822Z",
						fill: "#027ED4"
					}),
					/* @__PURE__ */ n("mask", {
						id: `${a}-mask0_218_75`,
						style: { maskType: "luminance" },
						maskUnits: "userSpaceOnUse",
						x: 0,
						y: 4,
						width: 35,
						height: 32,
						children: /* @__PURE__ */ n("path", {
							d: "M11.1822 4.4447C13.916 4.44488 16.5177 7.40827 19.2516 7.40827H25.5081C28.7544 7.40827 30.3773 7.40836 31.6173 8.05412C32.708 8.62218 33.5953 9.52788 34.1513 10.6427C34.7831 11.9104 34.7831 13.5704 34.7831 16.8893V24.8894C34.7831 28.623 34.7822 30.4895 34.0713 31.9155C33.4462 33.17 32.4489 34.1895 31.2215 34.8286C29.8264 35.5553 28.0006 35.5562 24.3481 35.5562H9.27492C6.02892 35.5562 4.40577 35.556 3.1658 34.9104C2.075 34.3422 1.18759 33.4351 0.631801 32.3202C0.000192194 31.0526 2.14117e-09 29.3932 0 26.0752V10.3701C0.000306495 7.09776 2.59537 4.44501 5.79661 4.4447H11.1822Z",
							fill: "white"
						})
					}),
					/* @__PURE__ */ n("g", {
						mask: `url(#${a}-mask0_218_75)`,
						children: /* @__PURE__ */ n("path", {
							d: "M19.2514 7.4083V8.14906H25.5079V7.4083V6.66756H19.2514V7.4083ZM25.5079 7.4083V8.14906C27.143 8.14906 28.3257 8.14964 29.256 8.22735C30.1775 8.30435 30.7873 8.45336 31.288 8.71418L31.6171 8.05415L31.9462 7.39414C31.2071 7.00921 30.3853 6.83527 29.374 6.75078C28.3711 6.667 27.119 6.66756 25.5079 6.66756V7.4083ZM31.6171 8.05415L31.288 8.71418C32.2429 9.21143 33.0193 10.004 33.5056 10.9791L34.1511 10.6427L34.7967 10.3064C34.1711 9.05188 33.1727 8.033 31.9462 7.39414L31.6171 8.05415ZM34.1511 10.6427L33.5056 10.9791C33.7607 11.491 33.9065 12.1146 33.9816 13.0571C34.0576 14.0083 34.0582 15.2177 34.0582 16.8893H34.7829H35.5076C35.5076 15.2421 35.508 13.962 35.4263 12.9365C35.3436 11.9024 35.1736 11.0621 34.7967 10.3064L34.1511 10.6427ZM34.7829 16.8893H34.0582V24.8894H34.7829H35.5076V16.8893H34.7829ZM34.7829 24.8894H34.0582C34.0582 26.7683 34.0576 28.133 33.9714 29.2074C33.886 30.2732 33.7202 30.9879 33.4256 31.5792L34.0711 31.9155L34.7169 32.2519C35.1329 31.4172 35.3232 30.4857 35.4158 29.3283C35.508 28.1794 35.5076 26.7441 35.5076 24.8894H34.7829ZM34.0711 31.9155L33.4256 31.5792C32.8698 32.6944 31.9831 33.6006 30.8924 34.1688L31.2213 34.8288L31.5504 35.4888C32.9138 34.7786 34.0222 33.6457 34.7169 32.2519L34.0711 31.9155ZM31.2213 34.8288L30.8924 34.1688C30.314 34.4699 29.6146 34.6395 28.572 34.7266C27.5211 34.8146 26.1861 34.8155 24.3479 34.8155V35.5562V36.2971C26.1624 36.2971 27.5664 36.2973 28.6904 36.2031C29.8226 36.1084 30.7338 35.9142 31.5504 35.4888L31.2213 34.8288ZM24.3479 35.5562V34.8155H9.27478V35.5562V36.2971H24.3479V35.5562ZM9.27478 35.5562V34.8155C7.63985 34.8155 6.45715 34.8148 5.52698 34.7373C4.60526 34.66 3.9954 34.5111 3.49455 34.2502L3.16566 34.9104L2.83668 35.5704C3.5758 35.9553 4.39759 36.1293 5.40891 36.2137C6.41181 36.2975 7.66372 36.2971 9.27478 36.2971V35.5562ZM3.16566 34.9104L3.49455 34.2502C2.5401 33.753 1.76363 32.9595 1.27732 31.9837L0.631656 32.3201L-0.0140465 32.6564C0.611222 33.9108 1.60951 34.9311 2.83668 35.5704L3.16566 34.9104ZM0.631656 32.3201L1.27732 31.9837C1.0222 31.4717 0.876477 30.8483 0.80114 29.9061C0.725112 28.9554 0.724503 27.7465 0.724503 26.0752H-0.00014472H-0.724792C-0.724792 27.7221 -0.725306 29.0019 -0.643336 30.027C-0.560673 31.0608 -0.390535 31.9008 -0.0140465 32.6564L0.631656 32.3201ZM-0.00014472 26.0752H0.724503V10.3702H-0.00014472L-0.724792 10.3701V26.0752H-0.00014472ZM-0.00014472 10.3702H0.724503C0.72477 7.50681 2.99544 5.18576 5.79654 5.18549L5.79647 4.44473V3.70398C2.19506 3.70433 -0.724446 6.68865 -0.724792 10.3701L-0.00014472 10.3702ZM5.79647 4.44473L5.79654 5.18549H11.1821V4.44473L11.1821 3.70398H5.79647V4.44473ZM11.1821 4.44473V5.18549C12.3292 5.18556 13.4925 5.81195 14.8708 6.57744C16.1603 7.2937 17.6648 8.14906 19.2514 8.14906V7.4083V6.66756C18.1042 6.66756 16.9409 6.04122 15.5627 5.27572C14.2732 4.55946 12.7687 3.70408 11.1821 3.70398L11.1821 4.44473Z",
							fill: `url(#${a}-paint0_linear_218_75)`
						})
					}),
					/* @__PURE__ */ n("path", {
						d: "M12.6936 12.222H28.2034C30.4699 12.222 32.1452 12.2224 33.4361 12.3418C34.7257 12.4612 35.5817 12.6978 36.2317 13.1335C37.4188 13.9296 38.2555 15.1689 38.5602 16.5867C38.7269 17.3626 38.6369 18.2643 38.2866 19.5381C37.936 20.8136 37.3382 22.4146 36.5306 24.5798L34.7626 29.3212C33.9312 31.5502 33.5439 32.5717 32.8943 33.3195C32.3108 33.9909 31.5774 34.5086 30.7561 34.8264C29.841 35.1806 28.7692 35.186 26.4354 35.186H10.9256C8.65866 35.186 6.98199 35.1855 5.69118 35.0662C4.40205 34.9466 3.54544 34.7118 2.89563 34.2762C1.70849 33.4802 0.873624 32.2404 0.56882 30.823C0.402022 30.0468 0.491968 29.1441 0.842263 27.8697C1.19291 26.5943 1.78922 24.9932 2.59669 22.8281L4.36474 18.0884C5.19628 15.8588 5.58317 14.8363 6.23294 14.0884C6.81637 13.4169 7.55131 12.9012 8.37292 12.5831C9.28802 12.229 10.3594 12.222 12.6936 12.222Z",
						fill: "#027ED4",
						stroke: `url(#${a}-paint1_linear_218_75)`,
						strokeWidth: .925938
					}),
					/* @__PURE__ */ n("path", {
						opacity: .2,
						d: "M4.02688 17.9561C4.84794 15.7546 5.25845 14.6539 5.96289 13.8431C6.58518 13.1268 7.36813 12.5754 8.24456 12.2362C9.23662 11.8522 10.389 11.8522 12.6938 11.8522H28.2033C32.7234 11.8522 34.9834 11.8522 36.4312 12.823C37.6977 13.6721 38.589 14.9943 38.9139 16.5065C39.2855 18.2353 38.4804 20.394 36.8701 24.7114L35.1019 29.4524C34.281 31.6537 33.8705 32.7546 33.1658 33.5653C32.5436 34.2815 31.7607 34.8329 30.8843 35.1722C29.8923 35.5562 28.7398 35.5562 26.4351 35.5562H10.9257C6.40556 35.5562 4.14551 35.5562 2.6976 34.5853C1.43108 33.7362 0.539978 32.4142 0.214949 30.9019C-0.156626 29.173 0.648493 27.0143 2.25873 22.6968L4.02688 17.9561Z",
						fill: `url(#${a}-paint2_linear_218_75)`
					}),
					/* @__PURE__ */ r("defs", { children: [
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint0_linear_218_75`,
							x1: 17.3914,
							y1: 4.44473,
							x2: 17.3914,
							y2: 35.5562,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint1_linear_218_75`,
							x1: 19.5641,
							y1: 11.8522,
							x2: 19.5641,
							y2: 35.5562,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", {
								stopColor: "white",
								stopOpacity: .12
							}), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						}),
						/* @__PURE__ */ r("linearGradient", {
							id: `${a}-paint2_linear_218_75`,
							x1: -2.53729,
							y1: 11.8522,
							x2: 21.9054,
							y2: 34.6251,
							gradientUnits: "userSpaceOnUse",
							children: [/* @__PURE__ */ n("stop", { stopColor: "white" }), /* @__PURE__ */ n("stop", {
								offset: 1,
								stopColor: "white",
								stopOpacity: 0
							})]
						})
					] })
				]
			});
		},
		width: 40,
		height: 40
	}
}, o = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: a[t],
	...r
});
//#endregion
export { o as FolderOpenIcon };
